import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import ButtonPrimary from "../ButtonPrimary";
import { InputModal } from "../InputModal";
import {
  AvatarContainer,
  Box,
  BoxColor,
  Button,
  ButtonBack,
  ButtonShared,
  ContainerModal,
  FlexInput,
  HorizontalStack,
  HStack,
  HStackBtn,
  InputBase,
  InputHex,
  Line,
  NameContainer,
  ProfileUser,
  Text,
  TextArea,
  Title,
  VerticalStack,
  WrapperProfileShared
} from "./styles";
import { AnimatePresence, motion } from "framer-motion";
import api from "../../../../services/api";
import { useModalContext } from "../../../../hooks/modalContext";
import { useSelection } from "../../hooks/selection";
import LetterAvatar from "../../../master/components/LetterAvatar";
import MultiplesAvatarLetter from "../../../master/components/MultiplesAvatarLetter";
import { useMainHook } from "../../../../hooks/main";
import { useSharedDocument } from "../../hooks/sharedDocument";
import { useParams } from "react-router-dom";
import { ButtonDeleteUserShared } from "../ModalSharedDocument/styles";
import IconSvg from "../IconSvg";
import deleteIcon from "../../assets/deleteIcon.svg";
import { getColors } from "../../utils/getColorAvatar";
import { Ring } from "react-spinners-css";
import closeIcon from "../../assets/close.svg";
import { useDiff } from "../../hooks/diffDocuments";

interface UsersSharedProps {
  id?: string;
  name?: string;
  email?: string;
  avatar_url?: string;
  permissions?: string;
  is_anonymous?: boolean;
}

interface ModalSharedInfoProps {
  isOpen: boolean;
  onRequestClose?: () => void;
}

export const ModalSharedInfo: React.FC<ModalSharedInfoProps> = ({
  isOpen,
  onRequestClose
}) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      scale: 1.2,
      transition: {
        delayChildren: 0.5,
        type: "spring",
        duration: 1,
        stiffness: 100,
        staggerDirection: -1
      }
    }
  };

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 1.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  const {
    currentTemplateInfo,
    myProfileId,
    objectScreen,
    handleOpenModalBlockFuncionalities
  } = useMainHook();

  const { hasGroupShared, updateIfGroup, setUpdateIfGroup } = useDiff();

  const { templateid } = useParams();
  const [sharedUsers, setSharedUsers] = useState<UsersSharedProps[]>([]);
  const { refreshUsersShared, setRefreshUsersShared } = useSharedDocument();
  const [isOwnerDocument, setIsOwnerDocument] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [indexDelete, setIndexDelete] = useState(0);
  const [toggleIsUsersShared, setToggleIsUsersShared] = useState(false);

  useEffect(() => {
    const autoLoadSharedUsers = async () => {
      try {
        const responseTemplatesUsers = await api.get(
          `user-share-template/all-shared-template-users/${templateid}`
        );
        setSharedUsers(responseTemplatesUsers.data.users);
      } catch (err) {
        console.log(err, "ERROR when fetch users shared template");
      }
    };

    autoLoadSharedUsers();
  }, [refreshUsersShared, toggleIsUsersShared]);

  const handleDeleteUserShare = useCallback(
    async (idUser: string, isAnnonymous: boolean, event, index) => {
      event.preventDefault();
      setIndexDelete(index);
      let userId = idUser;
      let documentId = templateid;
      let isUserAnnonymous = isAnnonymous ? 1 : 0;

      try {
        setLoadingDelete(true);
        const responseDeleteUserShare = await api.delete(
          `user-share-template/delete-user-share/${userId}/${documentId}/${isUserAnnonymous}`
        );

        setRefreshUsersShared(!refreshUsersShared);
        setLoadingDelete(false);
      } catch (err) {
        console.log(err, "ERROR when delete user shared");
        setLoadingDelete(false);
      }
    },
    [refreshUsersShared, indexDelete, loadingDelete]
  );

  useEffect(() => {
    setTimeout(() => {
      setForceUpdate(!forceUpdate);
    }, 2000);
  }, []);

  useEffect(() => {
    if (myProfileId) {
      const getOwnerId = sharedUsers.find(user => user.permissions === "Owner");

      if (getOwnerId?.id === myProfileId) {
        setIsOwnerDocument(true);
      } else {
        setIsOwnerDocument(false);
      }
    }
  }, [forceUpdate]);

  return (
    <Modal
      className="react-modal-content"
      overlayClassName="react-modal-overlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
    >
      <AnimatePresence>
        <ContainerModal
          as={motion.form}
          initial="hidden"
          animate="show"
          variants={container}
          exit={{
            opacity: 0,
            scale: 0.8,
            x: -300
          }}
          transition={{ duration: 1 }}
        >
          <button onClick={onRequestClose}>
            <IconSvg className="icon-exit" src={closeIcon} description="" />
          </button>
          <Title>Compartilhado - {currentTemplateInfo?.current?.title}</Title>
          <Line />
          {/* <HorizontalStack>
            <FlexInput>
              <InputBase type="text" placeholder="E-mail" />
            </FlexInput>

            <ButtonShared>Enviar convite</ButtonShared>
          </HorizontalStack> */}
          <VerticalStack>
            {sharedUsers?.map((user, index) => (
              <WrapperProfileShared key={user.id}>
                <AvatarContainer>
                  <MultiplesAvatarLetter
                    src={user.avatar_url}
                    text={user.name}
                    color={
                      user.permissions === "Owner"
                        ? getColors(true)
                        : getColors()
                    }
                    isAnnonymous={user.is_anonymous}
                  />
                </AvatarContainer>
                <NameContainer>
                  <ProfileUser isAnnonymous={user?.is_anonymous}>
                    {`${user.name} `}
                    {user.permissions === "Owner" ? (
                      <span style={{ marginLeft: "0.4rem" }}>
                        (proprietário)
                      </span>
                    ) : (
                      ""
                    )}
                  </ProfileUser>
                </NameContainer>
                {isOwnerDocument && index !== 0 && (
                  <ButtonDeleteUserShared
                    onClick={event => {
                      setToggleIsUsersShared(prevState => !prevState);
                      //verify changes for block download with marks of editions
                      let changes = false;

                      objectScreen.forEach((page, index) => {
                        page.renderObjects.forEach((renderedObject, index) => {
                          if (renderedObject.text && !changes) {
                            if (renderedObject.isModify) {
                              changes = true;
                            } else {
                              changes = false;
                            }
                          }
                        });
                      });

                      if (!changes) {
                        handleDeleteUserShare(
                          user.id,
                          user.is_anonymous,
                          event,
                          index
                        );

                        setUpdateIfGroup(prevState => !prevState);
                      } else {
                        onRequestClose();
                        handleOpenModalBlockFuncionalities("shared");
                      }
                    }}
                  >
                    {loadingDelete && indexDelete === index ? (
                      <Ring color="#110d0d" size={20} />
                    ) : (
                      <IconSvg
                        src={deleteIcon}
                        description=""
                        className="removeItem"
                      />
                    )}
                  </ButtonDeleteUserShared>
                )}
              </WrapperProfileShared>
            ))}
          </VerticalStack>
        </ContainerModal>
      </AnimatePresence>
    </Modal>
  );
};
